<template>
  <div class="dialog-container" v-loading="isLoading">
    <el-alert class="mb-3" :title="errorMessage" type="error" show-icon v-if="errorMessage"></el-alert>
    <el-row :gutter="18">
      <el-col :span="24">
        <el-form ref="logReferral" :model="form" :rules="rules" label-width="175px">
          <el-form-item label="RAF Code" prop="code">
            <masked-el-input :value="referral.code.toUpperCase()" @input="referral.code = $event.toUpperCase()"
              :mask="'AAA-AAA-AAA'" placeholder="Refer-A-Friend Code" />
          </el-form-item>
          <el-form-item label="New Client SSN" prop="newClientSSN">
            <masked-el-input v-model="referral.newClientSSN" :mask="'###-##-####'" placeholder="New Client's SSN" />
          </el-form-item>
          <el-form-item label="Confirm SSN" prop="confirmSSN">
            <masked-el-input v-model="confirmSSN" :mask="'###-##-####'" placeholder="Confirm Client's SSN" />
          </el-form-item>
          <el-form-item label="New Client Name" prop="newClientName">
            <el-input v-model="referral.newClientName" placeholder="New Client's Name" />
          </el-form-item>
          <el-form-item label="" prop="bypassVerifications" v-if="isAdmin">
            <el-checkbox v-model="referral.bypassVerifications">Bypass Referral Verifications</el-checkbox>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row :gutter="18" class="dialog-footer">
      <el-col :span="24" class="align-right">
        <el-button @click="closeDialog">Cancel</el-button>
        <el-button type="primary" @click="saveReferral">Log Referral</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import get from 'lodash/get';
import api from '@/api';
import { ReferralTO } from '@/model';
import MaskedElInput from '@/components/form-item/MaskedElInput.vue';
import {
  Required, RAFCode, SSN, GenericDoubleBlindValidation,
} from '@/util/formValidators';

export default {
  name: 'LogRAFDialog',
  props: {
    rafCode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isLoading: false,
      errorMessage: null,
      referral: new ReferralTO(),
      confirmSSN: null,
      rules: {
        code: [Required, RAFCode],
        newClientSSN: [Required, SSN],
        confirmSSN: [Required, SSN, { validator: this.mustMatch('form.newClientSSN'), trigger: 'blur' }],
        newClientName: [Required],
      },
    };
  },
  methods: {
    mustMatch(formItem) {
      return (...args) => {
        GenericDoubleBlindValidation(get(this, formItem), ...args);
      };
    },
    saveReferral() {
      this.$refs.logReferral.validate((valid) => {
        if (valid) {
          this.isLoading = true;
          api.referral.newReferral(this.referral).then((response) => {
            this.$notify.success({
              title: 'Success',
              message: 'The referral coupon has been recorded.',
              position: 'bottom-right',
            });
            this.$emit('addedReferral', response.data);
            this.clearForm();
            this.closeDialog();
          }).catch((e) => {
            this.errorMessage = get(e, 'response.data', 'An error occurred.');
          }).finally(() => {
            this.isLoading = false;
          });
          return true;
        }
        return false;
      });
    },
    closeDialog() {
      this.$emit('close');
      this.clearForm();
    },
    clearForm() {
      this.referral = new ReferralTO();
      this.errorMessage = null;
      this.confirmSSN = null;
      this.$refs.logReferral.resetFields();
      if (this.rafCode) {
        this.referral.code = this.rafCode;
      }
    },
  },
  mounted() {
    if (this.rafCode) {
      this.referral.code = this.rafCode;
    }
  },
  watch: {
    rafCode() {
      this.referral.code = this.rafCode;
    },
  },
  computed: {
    ...mapGetters('User', [
      'isAdmin',
    ]),
    form() {
      return {
        ...this.referral,
        confirmSSN: this.confirmSSN,
      };
    },
  },
  components: {
    MaskedElInput,
  },
};

</script>
